import React from 'react';
import PropTypes from 'prop-types';
import Swiper, { SwiperArrowType } from '@deporvillage/swiper-component';
import Picture from '@deporvillage/picture-component';
import { I18n } from "@deporvillage/utils-library-component";

import styles from './Related.module.scss';

const SwiperBreakpoints = {
    0: { spaceBetween: 5, freeMode: true },
};

const RelatedTypes = {
    Colour: 'colour',
    Flavour: 'flavour',
};

const Related = ({ type, options, onClick }) => (
    <div className={ styles['product-related-component'] }>
        <p className={ styles['product-action-title'] }>
            <I18n>{ `product_page.title.${ type }` }</I18n>
        </p>
        <Swiper breakpoints={ SwiperBreakpoints } arrows={SwiperArrowType.None} multiple scrollbar>
            { options.filter(option => option.image)
                .map(option => option.url ?
                    <a key={ option.id } href={ option.url } title={ option.name }
                        onClick={ () => onClick && onClick() }>
                        <Picture src={ `product/${ option.image }` } name={ option.name } height={ 82 }/>
                    </a>
                    :
                    <span className={ styles['active'] } key={ option.id } title={ option.name }>
                        <Picture src={ `product/${ option.image }` } name={ option.name } height={ 82 }/>
                    </span>
            )}
        </Swiper>
    </div>
);

Related.propTypes = {
    type: PropTypes.oneOf([RelatedTypes.Colour, RelatedTypes.Flavour]),
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        name: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.string,
    })),
    onClick: PropTypes.func,
};

export default Related;
